import ToolbarPopover from "@/appComponents/Navigation/ContextualToolbar/ToolbarPopover/ToolbarPopover";
import { List } from "@theorgchartdev/storybook";

/*
  type Props = {
    title?: string;
    options: ListItemValue[];
    overlayProps?: ComponentProps<OverlayHeader>;
    popoverProps?: ComponentProps<Popover>;
    listProps?: ComponentProps<List>;
    floatingCtrlRef?: Ref<...>;
    openCtrlRef?: Ref<...>;
  }
*/

const getHeaderProps = props => {
  if (props.title || props.overlayProps?.headerProps) {
    return {
      modifier: "default",
      size: "small",
      title: props.title,
      ...props.overlayProps?.headerProps
    };
  }
};

export const ContextMenu = props => (
  <ToolbarPopover
    show={props.options?.length > 0}
    overlayProps={{
      padding: 0,
      ...props.overlayProps,
      headerProps: getHeaderProps(props)
    }}
    otherPopoverProps={{
      offsetOptions: 10,
      reference: null,
      ...props.popoverProps,
      floatingCtrlRef: props.floatingCtrlRef,
      openCtrlRef: props.openCtrlRef,
      shiftOptions: { crossAxis: true }
    }}
  >
    <List showCheck={false} listWidth={"medium"} options={props.options} {...props.listProps} />
  </ToolbarPopover>
);
